<template>
  <div class="div-padding">
    <b-container class="pb-4wrapper title">
      <b-row class="text-left mt-sm-4-custom">
        <h1 class="text-1">
          <b>{{ $t("website.insurance.title.p1") }}</b>
          {{ $t("website.insurance.title.p2") }}
          <b>{{ $t("website.insurance.title.p3") }}</b>
          {{ $t("website.insurance.title.p4") }}
        </h1>
        <br />
      </b-row>
      <b-row class="d-flex text-left">
        <p
          class="md-font-size"
          v-html="$t('website.insurance.product.title')"
        ></p>
      </b-row>
      <b-row class="d-flex align-items-center icon-text">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 9.16667V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
            stroke="#4F4F4F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="10.0001" cy="6.25008" r="0.833333" fill="#4F4F4F" />
        </svg>
        <p
          class="md-font-size pt-3 pl-2"
          v-html="$t('website.insurance.product.pt1')"
        ></p>
      </b-row>
      <b-row class="d-flex align-items-center icon-text">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 9.16667V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
            stroke="#4F4F4F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="10.0001" cy="6.25008" r="0.833333" fill="#4F4F4F" />
        </svg>
        <p
          class="md-font-size pt-3 pl-2"
          v-html="$t('website.insurance.product.pt2')"
        ></p>
      </b-row>
      <b-row class="d-flex align-items-center icon-text">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 9.16667V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
            stroke="#4F4F4F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="10.0001" cy="6.25008" r="0.833333" fill="#4F4F4F" />
        </svg>
        <p
          class="md-font-size pt-3 pl-2"
          v-html="$t('website.insurance.product.pt3')"
        ></p>
      </b-row>
      <b-row class="mt-3 align-items-center">
        <span class="text-cus1">{{ $t("website.insurance.product.pt4") }}</span>
      </b-row>
      <b-row class="align-items-center">
        <button class="button-insurance" @click="scrollToElement">
          {{ $t("website.insurance.component.btn1") }}
        </button>
      </b-row>
      <b-row class="mt-2 align-items-center text-left">
        <span class="text-cus1">{{ $t("website.insurance.product.pt5") }}</span>
      </b-row>
      <b-row class="mt-4 align-items-center text-left">
        <div class="div-image"></div>
      </b-row>
      <b-row class="d-flex pt-5 align-items-center">
        <h6
          class="text-2"
          style="width: 520px"
          v-html="$t('website.insurance.product.pt6')"
        ></h6>
      </b-row>
    </b-container>
  </div>
</template>

<style lang="scss" scoped>
$large: 992px;
.bg-content {
  // background: #e5e5e5;
  // background-repeat: repeat;
  // background-size: contain;
  // background-position: top;

  @media screen and (min-width: $large) {
    // background-position: center;
    // background-size: cover;
    // position: relative;
  }
}
@media (max-width: 767px) {
  .mt-sm-4-custom {
    margin-top: 3.5rem !important;
  }
}

.div-padding {
  padding: 0% 5%;
}

.div-image {
  width: 95%;
  height: 75vh;
  flex-shrink: 0;
  border-radius: 15px;
  background: url("../assets/img/cyber-insurance-banner.webp"),
    lightgray -0.55px 0px / 100.075% 137.262% no-repeat;
  background-position: center;
  background-size: auto 100%;
  background-repeat: no-repeat;
}

.text-1 {
  color: var(--black-900, #12070b);
  /* H1 */
  font-family: Jost;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 1053px;
}

.text-2 {
  color: var(--black-900, #12070b);

  /* H6 */
  font-family: Jost;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.button-insurance {
  display: inline-flex;
  padding: 10px 15px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;
  background: linear-gradient(
    49deg,
    #0f3078 0%,
    #3c84d8 54.69%,
    #7dc5fd 95.83%
  );

  /* Btn1 */
  text-align: center;
  font-family: Jost;
  font-size: 18px; // original 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 31.79px;
}

.icon-text {
  height: 40px;
}

.text-cus1 {
  color: var(--black-700, #8a8a8a);
  /* SM */
  font-family: Jost;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 768px) {
  .div-image {
    background-size: cover;
    height: 20vh;
    border-radius: 15px;
  }
  .h1 {
    width: 362px;
    font-style: normal;
    font-weight: 600;
  }
  .text-1 {
    font-size: 40px !important;
  }
}
</style>

<script>
export default {
  methods: {
    scrollToElement() {
      const targetElement = document.getElementById("cyberInsTarget");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" }); // Scroll smoothly to the element
      }
    },
  },
};
</script>
